export default {
  methods: {
    showVideo(video, modalId = 'modalVideo') {
      if (process.client) {
        this.$store.dispatch('setVideo', video)
        this.$bvModal.show(modalId)
      }
    },
  },
}
